//判断Ajax请求是否失败
const isFailed = (response) => {
  let code = response.data.result_code
  return code!==0
}

//转换日期格式
const dateToString = function(dateS) {
  if(dateS) {
    let date = new Date(dateS)
    let Y = date.getFullYear()
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1)
    let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
    let H = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours())
    let Min = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())
    let S = (date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds())
    return `${Y}-${M}-${D} ${H}:${Min}:${S}`
  }
  return ''
}

const dateToStringShort = function(dateS) {
  return dateToString(dateS).substr(0, 10)
}

const fmtTime = function(row, col) {
  let val = row[col.property]
  return dateToString(val)
}

const fmtTimeShort = function(row, col) {
  if(row){
    let val = row[col.property]
    return dateToStringShort(val)
  }
}

const getRecentDateRange = function (recentSomeDays) {
  let dateArr = []
  let today = new Date();
  for(let i=1;i<=recentSomeDays;i++){
    let temp = new Date()
    let beforeToday = temp.setDate(today.getDate()-i)
    dateArr.push(this.dateToStringShort(beforeToday))
  }
  return dateArr.reverse()
}

export default {
  isFailed,
  dateToString,
  dateToStringShort,
  fmtTime,
  fmtTimeShort,
  getRecentDateRange
}



// WEBPACK FOOTER //
// ./src/util/index.js